import React from 'react'

import { DownloadOrder } from 'vendor/components/DownloadOrder/download_order'

interface Props {
  orderId: string
}

export const CellActions = ({ orderId }: Props) => (
  <span onClick={(event) => event.stopPropagation()}>
    <DownloadOrder orderId={orderId} />
  </span>
)
